import React, { useEffect } from "react";
import { GetAllData } from "../hooks/middleware.js";
import MapLightpoints from "./MapLightpoints.jsx";

export default function TileOverview({ id, lightpointsPerYear, setLightpointsPerYear }) {
  const { lightpointData, formData, error } = GetAllData(id);

  useEffect(() => { 
    if (lightpointData && lightpointData.length > 0 && lightpointsPerYear == 1) {
      let base = Math.round(lightpointData.length / 6);

      if (base > 10) {
        const step = base < 1000 ? 10 : 100;
        base = Math.round(base / step) * step;
      }

      setLightpointsPerYear(base);
    }
  }, [lightpointData, lightpointsPerYear, setLightpointsPerYear]);

  if (error) return <p>Error loading data.</p>;
  if (!lightpointData || !formData) return <p>Loading data...</p>;
  if (!lightpointData.length) return <p>No lightpoints found.</p>;

  const lightpointsTotal = lightpointData.length;
  const durationYears = Math.ceil(lightpointsTotal / lightpointsPerYear);

  return (
    <div style={{ display: "flex", gap: "2rem", alignItems: "stretch" }}>
      {/* Table column */}
      <div style={{ flex: "1", width: "50%" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem", color: "#555" }}>
          <tbody>
            <tr>
              <td className="overview-td">LP/Jahr Geplant</td>
              <td className="overview-td-bold">
                <input
                  type="number"
                  value={lightpointsPerYear}
                  min={0}
                  step={
                    lightpointsPerYear > 9999
                      ? 1000
                      : lightpointsPerYear > 99
                      ? 100
                      : lightpointsPerYear > 9
                      ? 10
                      : 1
                  }
                  onChange={(e) => setLightpointsPerYear(Math.max(Number(e.target.value), 1))}
                  onBlur={() => {
                    const step =
                      lightpointsPerYear > 9999
                        ? 1000
                        : lightpointsPerYear > 99
                        ? 100
                        : lightpointsPerYear > 9
                        ? 10
                        : 1;
                    setLightpointsPerYear(Math.round(lightpointsPerYear / step) * step);
                  }}
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "#555",
                    textAlign: "right",
                    width: "90px",
                    padding: "2px 6px",
                    border: "2px solid red",
                    borderRadius: "6px",
                    outline: "none",
                    backgroundColor: "white",
                  }}
                />{" "}
                / Jahr
              </td>
            </tr>
            <tr>
              <td className="overview-td">Dauer</td>
              <td className="overview-td-bold">{durationYears} Jahre</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Map column */}
      <div style={{ flex: "1", width: "50%" }}>
        <MapLightpoints id={id} lightpoints={lightpointData} />
      </div>
    </div>
  );
}
